
document.addEventListener("DOMContentLoaded", function () {
  const CONFIG = {
    required: { tshirt: 12, jacket: 2, polo: 6, hoodie: 3 },
    sections: [
      { key: "jacket", title: "Jacket Sizes", ids: ["number-13","number-14","number-15","number-16","number-17","number-18"], required: 2 },
      { key: "tshirt", title: "T-Shirt Sizes", ids: ["number-1","number-3","number-4","number-5","dropdown-1","dropdown-2"], required: 12 },
      { key: "polo", title: "Polo Sizes", ids: ["number-19","number-20","number-21","number-22","number-23","number-24"], required: 6, checkbox: "checkbox-6" },
      { key: "hoodie", title: "Optional Carhartt Hoodie Sizes", ids: ["number-25","number-26","number-27","number-28","number-29","number-30"], required: 3, checkbox: "checkbox-8" }
    ],
    afterSizes: ["divider-4","heading-1","checkbox-1","divider-1","file-1","file-2","textarea-1","checkbox-5","radio-1","paragraph-1"]
  };

  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => Array.from(root.querySelectorAll(s));
  const wrapper = id => $('[data-element-id="' + id + '"]');
  const section = key => CONFIG.sections.find(s => s.key === key);
  const heading = key => $("#bundle-heading-" + key);
  const normalize = value => String(value || "").trim().toLowerCase();

  let initialized = false;
  let nativeAdd = null;
  let nativeGpo = null;
  let updating = false;

  const COLORS = {
    "black":"#111111",
    "navy":"#1f2a44",
    "moss":"#62664a",
    "shadow grey":"#777777",
    "brite lime":"#bcd334",
    "black / white":"#5b5b5b",
    "brite orange":"#ea6030",
    "carhartt brown":"#9a633e",
    "coal heather":"#313030",
    "dark brown/sandstone":"#3b2b1b",
    "heather grey":"#9e9d9d"
  };

  function getCheckbox(s) {
    if (!s.checkbox) return null;
    let el = wrapper(s.checkbox);
    if (!el && s.key === "polo") {
      el = $$("[data-element-id]").find(w =>
        (w.textContent || "").includes("Premium Dri-Fit Custom Embroidered Polo 50% off")
      );
    }
    return el ? $('input[type="checkbox"]', el) : null;
  }

  function active(s) {
    if (!s.checkbox) return true;
    const cb = getCheckbox(s);
    return !!(cb && cb.checked);
  }

  function value(id) {
    const el = wrapper(id);
    if (!el) return 0;
    if (id.startsWith("dropdown")) {
      const checked = $('input[type="radio"]:checked', el);
      if (checked) return Number(checked.value) || 0;
      const select = $("select", el);
      return select ? Number(select.value) || 0 : 0;
    }
    const input = $("#" + id) || $('input[type="number"]', el) || $("input", el);
    return input ? Number(input.value) || 0 : 0;
  }

  function total(s) {
    return s.ids.reduce((sum, id) => sum + value(id), 0);
  }

  function valid(s) {
    return !active(s) || total(s) === s.required;
  }

  function bundleValid() {
    return CONFIG.sections.every(valid);
  }

  function show(s, visible) {
    const h = heading(s.key);
    if (h) h.style.display = visible ? "flex" : "none";
    s.ids.forEach(id => {
      const el = wrapper(id);
      if (el) el.style.display = visible ? "" : "none";
    });
  }

  function clearSizes(s) {
    s.ids.forEach(id => {
      const el = wrapper(id);
      if (!el) return;
      $$('input[type="number"]', el).forEach(input => {
        if (input.value && input.value !== "0") {
          input.value = "0";
          input.dispatchEvent(new Event("change", { bubbles: false }));
        }
      });
    });
  }

  function positionOptional(s) {
    const cb = getCheckbox(s);
    if (!cb) return;
    const cbWrapper = cb.closest("[data-element-id]");
    if (!cbWrapper) return;

    const items = [
      heading(s.key),
      ...s.ids.map(wrapper)
    ].filter(Boolean);

    let anchor = cbWrapper;
    items.forEach(el => {
      if (el !== anchor && el.parentNode === anchor.parentNode) {
        anchor.insertAdjacentElement("afterend", el);
        anchor = el;
      }
    });
  }

  function updateVisibility() {
    ["number-7","number-8","number-10","number-9","number-11","number-12"].forEach(id => {
      const el = wrapper(id);
      if (el) el.style.display = "none";
    });

    ["polo","hoodie"].forEach(key => {
      const s = section(key);
      positionOptional(s);
      show(s, active(s));
      if (!active(s)) clearSizes(s);
    });

    const jacketsValid = valid(section("jacket"));
    const tshirtsValid = valid(section("tshirt"));

    show(section("jacket"), true);
    show(section("tshirt"), jacketsValid);

    CONFIG.afterSizes.forEach(id => {
      const el = wrapper(id);
      if (el) el.style.display = jacketsValid && tshirtsValid ? "" : "none";
    });
  }

  function updateHeadings() {
    CONFIG.sections.forEach(s => {
      const h = heading(s.key);
      if (!h) return;
      const count = $("#" + s.key + "-count");
      if (count) count.textContent = total(s);

      if (!active(s)) {
        h.style.display = "none";
        return;
      }

      const ok = valid(s);
      h.style.background = ok ? "#f0fff4" : "#fff8f8";
      h.style.border = ok ? "1px solid #b8e6c0" : "1px solid #ffd0d0";
      h.style.color = ok ? "#0a7a24" : "#b00020";
    });
  }

  function updateTotalBox() {
    const box = $("#bundleStrictTotal");
    if (!box) return;

    const parts = [
      "Jacket Total: " + total(section("jacket")) + " / 2",
      "T-Shirt Total: " + total(section("tshirt")) + " / 12"
    ];

    if (active(section("polo"))) {
      parts.push("Polo Total: " + total(section("polo")) + " / 6");
    }
    if (active(section("hoodie"))) {
      parts.push("Hoodie Total: " + total(section("hoodie")) + " / 3");
    }

    box.innerHTML = parts.join(" &nbsp; | &nbsp; ");
    const ok = bundleValid();
    box.style.background = ok ? "#f0fff4" : "#fff8f8";
    box.style.border = ok ? "1px solid #b8e6c0" : "1px solid #ffd0d0";
    box.style.color = ok ? "#0a7a24" : "#b00020";
  }

  function updateSummary() {
    const t = total(section("tshirt"));
    const j = total(section("jacket"));
    const p = total(section("polo"));
    const h = total(section("hoodie"));
    const poloActive = active(section("polo"));
    const hoodieActive = active(section("hoodie"));

    const setText = (id, text) => {
      const el = $("#" + id);
      if (el) el.textContent = text;
    };

    setText("tss-summary-tshirt", t + " / 12");
    setText("tss-summary-hoodie", j + " / 2");
    setText("tss-summary-jacket", "12 beanies");
    setText("tss-summary-polo", p + " / 6");
    setText("tss-summary-hoodie-addon", h + " / 3");

    const poloRow = $("#tss-summary-polo-row");
    const hoodieRow = $("#tss-summary-hoodie-addon-row");
    if (poloRow) poloRow.style.display = poloActive ? "flex" : "none";
    if (hoodieRow) hoodieRow.style.display = hoodieActive ? "flex" : "none";

    const progress = (
      Math.min(t / 12, 1) +
      Math.min(j / 2, 1) +
      (poloActive ? Math.min(p / 6, 1) : 1) +
      (hoodieActive ? Math.min(h / 3, 1) : 1)
    ) / 4 * 100;

    const bar = $("#tss-progress-bar");
    if (bar) bar.style.width = progress + "%";

    let message = "Your pack is complete and ready to add to cart.";
    if (j !== 2) message = "Choose exactly 2 Jackets to unlock T-shirts.";
    else if (t !== 12) message = "Great — now choose exactly 12 T-shirts.";
    else if (poloActive && p !== 6) message = "Complete the optional polo sizes: exactly 6.";
    else if (hoodieActive && h !== 3) message = "Complete the optional hoodie sizes: exactly 3.";

    setText("tss-progress-copy", message);

    const btn = $("#tss-proxy-add");
    if (btn) {
      btn.disabled = !bundleValid();
      btn.textContent = bundleValid() ? "Add complete pack to cart" : "Complete sizes to continue";
    }
  }

  function syncPrice() {
    const selectors = [
      ".price__container .price-item--sale",
      ".price__container .price-item--regular",
      ".product__info-container .price-item--sale",
      ".product__info-container .price-item--regular",
      ".price .price-item"
    ];

    let price = "";
    for (const selector of selectors) {
      const el = $(selector);
      if (el && el.textContent.trim()) {
        price = el.textContent.trim();
        break;
      }
    }
    if (price) $$("[data-tss-price]").forEach(el => el.textContent = price);
  }

  function nativeColorControls() {
    return $$(
      'variant-selects input[type="radio"],variant-radios input[type="radio"],' +
      '.product-form__input input[type="radio"],variant-selects select,' +
      'variant-radios select,.product-form__input select'
    ).filter(control => {
      const group = control.closest("fieldset,.product-form__input,variant-selects,variant-radios");
      const label = group && $("legend,.form__label,label", group);
      const name = (label && label.textContent) ||
        control.getAttribute("data-option-name") || control.name || "";
      return /color|colour/i.test(name);
    });
  }

  function syncColorButtons() {
    let selected = "";
    nativeColorControls().some(control => {
      if (control.matches('input[type="radio"]') && control.checked) {
        selected = control.value;
        return true;
      }
      if (control.tagName === "SELECT" && control.value) {
        selected = control.selectedOptions[0]?.textContent || control.value;
        return true;
      }
      return false;
    });

    if (!selected) return;
    $$(".tss-color-btn").forEach(btn => {
      const yes = normalize(btn.dataset.tssColorValue) === normalize(selected);
      btn.classList.toggle("is-selected", yes);
      btn.setAttribute("aria-pressed", String(yes));
    });
  }

  function selectColor(value) {
    const wanted = normalize(value);
    for (const control of nativeColorControls()) {
      if (control.matches('input[type="radio"]')) {
        if (normalize(control.value) !== wanted) continue;
        if (!control.checked) control.click();
        control.dispatchEvent(new Event("change", { bubbles: true }));
        break;
      }
      if (control.tagName === "SELECT") {
        const option = Array.from(control.options).find(o =>
          normalize(o.value) === wanted || normalize(o.textContent) === wanted
        );
        if (!option) continue;
        control.value = option.value;
        control.dispatchEvent(new Event("change", { bubbles: true }));
        break;
      }
    }
    setTimeout(syncColorButtons, 50);
    setTimeout(syncPrice, 100);
  }

  function initColors() {
    $$(".tss-color-btn").forEach(btn => {
      btn.addEventListener("click", () => selectColor(btn.dataset.tssColorValue));
    });
    $$("[data-tss-fallback-color]").forEach(el => {
      const name = el.dataset.tssFallbackColor;
      el.style.background = COLORS[normalize(name)] || name;
    });
    syncColorButtons();
  }

  function findNativeAdd() {
    const candidates = $$(
      'button[name="add"],.product-form__submit,form[action*="/cart/add"] button[type="submit"]'
    );
    nativeAdd = candidates.find(btn =>
      btn.id !== "tss-proxy-add" && !btn.closest("#tss-premium-builder")
    ) || null;
    if (nativeAdd) nativeAdd.classList.add("tss-native-add-hidden");
  }

  function lockNativeAdd() {
    if (!nativeAdd) findNativeAdd();
    if (!nativeAdd) return;
    nativeAdd.disabled = !bundleValid();
    nativeAdd.setAttribute("aria-disabled", String(!bundleValid()));
  }

  function showError() {
    const box = $("#bundleStrictError");
    if (!box) return;
    const errors = CONFIG.sections.filter(s => active(s) && !valid(s))
      .map(s => s.title + " must equal exactly " + s.required +
        ". Current total: " + total(s) + ".");
    box.innerHTML = errors.join("<br>");
    box.style.display = errors.length ? "block" : "none";
    if (errors.length) box.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  function submitNativeForm() {
    if (!bundleValid()) {
      showError();
      return;
    }
    if (!nativeAdd) findNativeAdd();
    if (nativeAdd) {
      nativeAdd.disabled = false;
      nativeAdd.click();
      return;
    }
    const form = $('form[action*="/cart/add"]');
    if (form) {
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    }
  }

  function updateAll() {
    if (!initialized || updating) return;
    updating = true;
    try {
      $$(".gpo-number, #tss-premium-builder input[type='number']").forEach(input => {
        if (Number(input.value) < 0) input.value = 0;
      });
      updateVisibility();
      updateHeadings();
      updateTotalBox();
      updateSummary();
      lockNativeAdd();
      syncPrice();
      const error = $("#bundleStrictError");
      if (error && bundleValid()) error.style.display = "none";
    } finally {
      updating = false;
    }
  }

  function bindEvents() {
    document.addEventListener("input", event => {
      if (event.target.matches('.gpo-number,input[type="number"]') ||
          event.target.closest(".gpo-group__childs")) updateAll();
    }, true);

    document.addEventListener("change", () => {
      updateAll();
      syncColorButtons();
      setTimeout(updateAll, 150);
      setTimeout(updateAll, 400);
    }, true);

    $("#tss-proxy-add")?.addEventListener("click", submitNativeForm);

    $("#tss-bottom-add")?.addEventListener("click", () => {
      if (!bundleValid()) {
        $("#tss-build-pack")?.scrollIntoView({ behavior: "smooth", block: "start" });
        showError();
      } else submitNativeForm();
    });

    $$("[data-tss-jump]").forEach(btn => {
      btn.addEventListener("click", () => {
        $("#tss-build-pack")?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    document.addEventListener("submit", event => {
      if (!event.target.matches?.('form[action*="/cart/add"]')) return;
      if (!bundleValid()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showError();
      }
    }, true);

    const priceArea = $(".price,.product__info-container");
    if (priceArea) {
      new MutationObserver(syncPrice).observe(priceArea, {
        subtree: true, childList: true, characterData: true
      });
    }
  }

  function init() {
    if (initialized) return;
    nativeGpo = $(".gpo-group__childs");
    if (!nativeGpo) {
      setTimeout(init, 400);
      return;
    }

    const requiredLoaded = CONFIG.sections.filter(s => !s.checkbox)
      .every(s => s.ids.every(id => !!wrapper(id)));
    if (!requiredLoaded) {
      setTimeout(init, 400);
      return;
    }

    const fragment = document.createDocumentFragment();
    CONFIG.sections.forEach(s => {
      s.ids.forEach(id => {
        const el = wrapper(id);
        if (el) fragment.appendChild(el);
      });
    });
    nativeGpo.insertBefore(fragment, nativeGpo.firstChild);

    const slot = $("#tss-globo-slot");
    if (slot) slot.appendChild(nativeGpo);

    ["bundleStrictTotal","bundleStrictError",
     ...CONFIG.sections.map(s => "bundle-heading-" + s.key)
    ].forEach(id => $("#" + id)?.remove());

    const totalBox = document.createElement("div");
    totalBox.id = "bundleStrictTotal";
    const errorBox = document.createElement("div");
    errorBox.id = "bundleStrictError";
    errorBox.style.display = "none";
    nativeGpo.insertBefore(errorBox, nativeGpo.firstChild);
    nativeGpo.insertBefore(totalBox, errorBox);

    CONFIG.sections.forEach(s => {
      const first = wrapper(s.ids[0]);
      if (!first) return;
      const h = document.createElement("div");
      h.id = "bundle-heading-" + s.key;
      h.className = "bundle-section-heading";
      h.innerHTML = "<span>" + s.title + "</span><span><span id='" +
        s.key + "-count'>0</span> / " + s.required + "</span>";
      first.insertAdjacentElement("beforebegin", h);
    });

    $$(".gpo-number,#tss-premium-builder input[type='number']").forEach(input => {
      input.min = "0";
      input.step = "1";
      input.setAttribute("inputmode", "numeric");
    });

    initialized = true;
    document.body.classList.add("tss-premium-active");
    findNativeAdd();
    initColors();
    bindEvents();
    updateAll();
  }

  init();
});
